import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isModalActive: false
}

const aiSlice = createSlice({
    name: 'ai',
    initialState,
    reducers: {
        setAiModalActive: (state, action) => {
            state.isModalActive = action.payload
        },
    },
})

export const { setAiModalActive } = aiSlice.actions
export default aiSlice.reducer 